export const DEFAULT_FILTERS_VALUES = {
  OPERADORA: [],
  REDE: [],
  AQUISICAO: {
    DE: null,
    ATE: null
  },
  ATIVACAO: {
    DE: null,
    ATE: null
  },
  ULTIMO_EVENTO: {
    DE: null,
    ATE: null
  }
}

export const FILTROS = {
  grupo1: ['OPERADORA', 'REDE', 'STATUS', 'TECNOLOGIA', 'TRAFEGO', 'CONEXOES'],
  grupo2: [
    'ULTIMO_EVENTO',
    'PLANO_TIPO',
    'ENVIO_SMS',
    'TIPO_SIMCARD',
    'PACOTE_EXTRA',
    'PACOTES'
  ],
  grupo3: [
    'VALOR',
    'DIAS_UTILIZADOS',
    'AQUISICAO',
    'ATIVACAO',
    'SERVICOS_ADICIONAIS',
    'CONSUMO'
  ],
  grupo4: [
    'SALDO',
    'ICCID_INTERVALO',
    'MARCA_MODELO',
    'GRUPO',
    'STATUS_CONTRATO',
    'CLIENTE_FINAL'
  ]
}

export const DELETE_KEYS = [
  'CONEXOES_MIN',
  'CONEXOES_MAX',
  'PACOTES_MIN',
  'PACOTES_MAX',
  'CONSUMO_MIN',
  'CONSUMO_MAX',
  'SALDO_MAX',
  'AQUISICAO_FINAL',
  'ATIVACAO_FINAL',
  'DIAS_USADOS_MAX',
  'RANGE_ICCID_MAX',
  'PLANO_MAX'
]

export const OPERADORA_OU_REDE = ['OPERADORA', 'REDE']

export const CHAVES_PADROES = [
  'MARCA',
  'ULTIMA_CONEXAO',
  'TRAFEGO',
  'MODELO',
  'TECNOLOGIA',
  'TIPO_SIMCARD',
  'PACOTE_EXTRA',
  'PLANO_TIPO',
  'CLIENTE_FINAL_CODIGO',
  'CLIENTE_FINAL_NOME',
  'SMS_ATIVADO'
]

export const DIAS_UTILIZADOS = ['DIAS_USADOS_MIN', 'RANGE_ICCID_MIN']

export const GRUPO_OU_STATUS_CONTRATO = ['GRUPO', 'STATUS_CONTRATO']

export const PACOTES_CONEXOES_CONSUMO = ['PACOTES', 'CONEXOES', 'CONSUMO']

export const INTERVALO_DE_DATAS = [
  'ULTIMA_CONEXAO_INICIO',
  'ULTIMA_CONEXAO_FINAL',
  'AQUISICAO_INICIO',
  'ATIVACAO_INICIO'
]

export const VALOR_MAX_MIN = ['VALOR_MIN', 'VALOR_MAX']

export const STATUS_LABEL = {
  ultima_conexao: 'Offline',
  online: 'Online',
  estoque: 'Estoque'
}

export const MOCK_FILTROS = {
  OPERADORA: [],
  REDE: [],
  SIMCARD_TIPO: [],
  GRUPOS: [],
  GRUPO: [],
  SERVICOS_ADICIONAIS: [],
  STATUS_CONTRATO: [],
  MARCA: [],
  MODELO: [],
  STATUS: [
    { label: 'Online', value: 'online' },
    { label: 'Offline', value: 'ultima_conexao' },
    { label: 'Estoque', value: 'estoque' },
    { label: 'Todos', value: 'todos' }
  ],
  TECNOLOGIA: [
    { label: '2G', value: '2G' },
    { label: '3G', value: '3G' },
    { label: 'NB-IoT', value: 'NB' },
    { label: '4G', value: '4G' },
    { label: 'Outras', value: 'OUTRAS' },
    { label: 'Todos', value: 'todos' }
  ],
  TRAFEGO: [
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Bloqueado', value: 'Bloqueado' },
    { label: 'Suspenso', value: 'Suspenso' },
    { label: 'Todos', value: 'todos' }
  ],
  PLANO_TIPO: [
    { label: 'Individual', value: 'Individual' },
    { label: 'Compartilhado', value: 'Compartilhado' },
    { label: 'Todos', value: 'todos' }
  ],
  ENVIO_SMS: [
    { label: 'Liberado', value: '1' },
    { label: 'Bloqueado', value: '0' },
    { label: 'Todos', value: 'todos' }
  ],
  TIPO_SIMCARD: [
    { label: 'Normal', value: 'Normal' },
    { label: 'Triplo corte', value: 'Triplo corte' },
    { label: 'Micro', value: 'Micro' },
    { label: 'Nano', value: 'Nano' },
    { label: 'Todos', value: 'todos' }
  ],
  PACOTE_EXTRA: [
    { label: 'Com', value: 'Com' },
    { label: 'Sem', value: 'Sem' },
    { label: 'Todos', value: 'todos' }
  ]
}
